// extracted by mini-css-extract-plugin
export default {"accountBreadcrumbs":"Im-z","hideOnMobile":"Jm-z"};